import * as Actions from 'app/store/actions/user/user.actions';

const initialState = {
	authToken: "",
	email: "",
	group_type: {id: null, name: ""},
	id: null,
	is_active: true,
	is_verified: true,
	last_login: "",
	name: "",
	position: null,
	profile_image: "",
	shortName: "",
	user_type: {id: null, name: "", sortname: ""},
	userstatus: ""
}

const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.UPDATE_AVATAR: {
			console.log("UPDATE_AVATAR REDUCER", action)
			return {
				...state,
				profile_image: action.avatar
			};
		}
		case Actions.UPDATE_USER_STATUS: {
			console.log("UPDATE_USER_STATUS userConnected", action)
			return {
				...state,
				userstatus: action.status
			};
		}
		case Actions.GET_USER_DATA:
			return {
				...initialState,
				...action.payload,
			};
		case Actions.SET_CURRENT_USER_DATA: {
			
			return {
				...state,
				...action.payload,
			}
		}
		case Actions.GET_USER_CONN_DATA:
			console.log("GET_USER_CONN_DATA",action)
			return {
				...initialState,
				...action.data,
			};
		default:
			return state;
	}
};

export default userReducer;
